import React, { useEffect, useState } from 'react';
import '../styles/profile.pro.css';
import { useNavigate } from 'react-router-dom';
import { getStoredUser, logoutUser } from '../utils/auth';

const searchableItems = [
  { title: 'Métodos de Pago', category: 'Pagos', icon: '💳', section: 'payment-methods-section' },
  { title: 'Agregar Tarjeta', category: 'Pagos', icon: '➕', section: 'payment-methods-section' },
  { title: 'Historial de Pagos', category: 'Pagos', icon: '📊', section: 'payment-history-section' },
  { title: 'Descargar Factura', category: 'Pagos', icon: '📥', section: 'payment-history-section' },
  { title: 'Información de la Cuenta', category: 'Cuenta', icon: '👤', section: 'account-info-section' },
  { title: 'Datos Personales', category: 'Cuenta', icon: '📝', section: 'account-info-section' },
  { title: 'Plan Activo', category: 'Suscripción', icon: '💎', section: 'active-plan-section' },
  { title: 'Cerrar Sesión', category: 'Seguridad', icon: '🚪', section: 'logout-section' }
];

export default function Profile() {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);
  const [searchActive, setSearchActive] = useState(false);
  const [toast, setToast] = useState({ show: false, message: '' });
  const [logoutModal, setLogoutModal] = useState(false);
  const navigate = useNavigate();

  const [userObj, setUserObj] = useState({ name: 'Juan Pérez', email: 'juan.perez@ejemplo.com' });
  const [avatarInitials, setAvatarInitials] = useState('JP');

  useEffect(() => {
    if (!query) { setSearchActive(false); setResults([]); return; }
    const q = query.toLowerCase().trim();
    const filtered = searchableItems.filter(item => item.title.toLowerCase().includes(q) || item.category.toLowerCase().includes(q));
    setResults(filtered);
    setSearchActive(true);
  }, [query]);

  function navigateToSection(sectionId) {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setSearchActive(false); setQuery('');
      section.style.transition = 'background 0.5s';
      section.style.background = '#fef5f1';
      setTimeout(() => { section.style.background = ''; }, 1000);
    }
  }

  function showToast(message) {
    setToast({ show: true, message });
    setTimeout(() => setToast({ show: false, message: '' }), 3000);
  }

  function handleSaveAccount(e) {
    e.preventDefault();
    showToast('Cambios guardados exitosamente');
  }

  async function handleLogoutConfirm() {
    setLogoutModal(false);
    await logoutUser();
    showToast('Sesión cerrada. Redirigiendo...');
    setTimeout(() => navigate('/login', { replace: true }), 1000);
  }

  useEffect(() => {
    // load real user from localStorage if available
    const defaultName = 'Juan Pérez';
    const defaultEmail = 'juan.perez@ejemplo.com';
    try {
      const parsed = getStoredUser();
      if (parsed) {
        const name = parsed.name || parsed.fullName || parsed.username || parsed.email || defaultName;
        const email = parsed.email || defaultEmail;
        setUserObj({ name, email });
        const parts = name.trim().split(/\s+/).filter(Boolean);
        setAvatarInitials(parts.length === 1 ? parts[0].slice(0,2).toUpperCase() : (parts[0][0] + parts[parts.length-1][0]).toUpperCase());
      }
    } catch (e) {
      // ignore
    }

    // elementSdk integration if available
    if (window.elementSdk && window.elementSdk.init) {
      const defaultConfig = {};
      window.elementSdk.init({
        defaultConfig,
        onConfigChange: (cfg) => {
          const companyName = cfg.company_name || 'Ker';
          const profileTitle = cfg.profile_title || 'Mi Perfil';
          const userName = cfg.user_name || 'Usuario';
          const userEmail = cfg.user_email || '';
          const primaryColor = cfg.primary_color || '#ec673b';
          const surfaceColor = cfg.surface_color || '#ffffff';
          const compEl = document.getElementById('company-name');
          if (compEl) compEl.textContent = companyName;
          const titleEl = document.getElementById('profile-title');
          if (titleEl) titleEl.textContent = profileTitle;
          const userNameEl = document.getElementById('user-name');
          if (userNameEl) userNameEl.textContent = userName;
          const userEmailEl = document.getElementById('user-email');
          if (userEmailEl) userEmailEl.textContent = userEmail;
          const wrapper = document.querySelector('.profile-wrapper');
          if (wrapper) wrapper.style.background = `linear-gradient(135deg, #fef5f1 0%, ${surfaceColor} 100%)`;
          const companyNameEl = document.querySelector('.company-name');
          if (companyNameEl) companyNameEl.style.color = primaryColor;
        }
      });
    }
  }, []);

  return (
    <div className="profile-wrapper">
      <div className="profile-container">
        <div className="profile-header">
          <div className="header-top">
            <div className="header-left">
              <img src="/logo512.png" alt="Ker Logo" className="logo-icon" />
              <div>
                <div className="company-name" id="company-name">Ker</div>
                <h1 className="profile-title" id="profile-title">Mi Perfil</h1>
              </div>
            </div>
            <div style={{flex:1, marginLeft: '1rem'}}>
              <div className="search-container">
                <span className="search-icon">🔍</span>
                <input value={query} onChange={e=>setQuery(e.target.value)} type="text" className="search-input" placeholder="Buscar secciones, opciones, ajustes..." autoComplete="off" />
                <div className={`search-results ${searchActive ? 'active' : ''}`}>
                  {results.length === 0 ? <div className="no-results">No se encontraron resultados</div> : results.map((item, i)=> (
                    <div key={i} className="search-result-item" onClick={() => navigateToSection(item.section)}>
                      <span className="search-result-icon">{item.icon}</span>
                      <div className="search-result-text">
                        <div className="search-result-title">{item.title}</div>
                        <div className="search-result-category">{item.category}</div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="user-card">
          <div className="user-info-top">
            <div className="user-avatar" id="user-avatar">{avatarInitials}</div>
            <div className="user-details">
              <h2 className="user-name" id="user-name">{userObj.name}</h2>
              <p className="user-email" id="user-email">{userObj.email}</p>
              <p className="user-member-since">Miembro desde Enero 2023</p>
            </div>
            <button className="edit-profile-btn" onClick={() => showToast('Función de edición disponible próximamente')}> ✏️ Editar Perfil </button>
          </div>
        </div>

        <div className="profile-section" id="payment-methods-section">
          <div className="section-header">
            <h3 className="section-title"><span className="section-icon">💳</span> Métodos de Pago</h3>
            <button className="add-btn" onClick={() => showToast('Agregar nueva tarjeta - Funcionalidad próximamente')}> + Agregar Tarjeta </button>
          </div>
          <div className="payment-cards">
            <div className="payment-card primary">
              <div className="card-badge">Principal</div>
              <div className="card-chip" />
              <div className="card-number">•••• •••• •••• 4532</div>
              <div className="card-footer">
                <div className="card-holder"><div style={{fontSize:'0.7rem', opacity:0.8}}>TITULAR</div><div>Juan Pérez</div></div>
                <div className="card-expiry"><div style={{fontSize:'0.7rem', opacity:0.8}}>VENCE</div><div>12/25</div></div>
              </div>
            </div>
            <div className="payment-card">
              <div className="card-chip" />
              <div className="card-number">•••• •••• •••• 8921</div>
              <div className="card-footer">
                <div className="card-holder"><div style={{fontSize:'0.7rem', opacity:0.8}}>TITULAR</div><div>Juan Pérez</div></div>
                <div className="card-expiry"><div style={{fontSize:'0.7rem', opacity:0.8}}>VENCE</div><div>08/26</div></div>
              </div>
            </div>
          </div>
        </div>

        <div className="profile-section" id="payment-history-section">
          <div className="section-header"><h3 className="section-title"><span className="section-icon">📊</span> Historial de Pagos</h3></div>
          <table className="payment-table">
            <thead><tr><th>Fecha</th><th>Descripción</th><th>Monto</th><th>Estado</th><th>Factura</th></tr></thead>
            <tbody>
              <tr><td>15 Dic 2024</td><td>Plan Básico - Mensual</td><td>$49.00</td><td><span className="status-badge completed">✓ Pagado</span></td><td><button className="download-btn" onClick={()=>showToast('Descargando factura...')}>📥 Descargar</button></td></tr>
              <tr><td>15 Nov 2024</td><td>Plan Básico - Mensual</td><td>$49.00</td><td><span className="status-badge completed">✓ Pagado</span></td><td><button className="download-btn" onClick={()=>showToast('Descargando factura...')}>📥 Descargar</button></td></tr>
            </tbody>
          </table>
        </div>

        <div className="profile-section" id="account-info-section">
          <div className="section-header"><h3 className="section-title"><span className="section-icon">👤</span> Información de la Cuenta</h3></div>
          <form id="account-form" onSubmit={handleSaveAccount}>
            <div className="info-grid">
              <div className="info-item"><label className="info-label" htmlFor="full-name">Nombre Completo</label><input className="info-value" id="full-name" defaultValue="Juan Pérez" /></div>
              <div className="info-item"><label className="info-label" htmlFor="email">Correo Electrónico</label><input className="info-value" id="email" defaultValue="juan.perez@ejemplo.com" /></div>
              <div className="info-item"><label className="info-label" htmlFor="phone">Teléfono</label><input className="info-value" id="phone" defaultValue="+52 555 123 4567" /></div>
              <div className="info-item"><label className="info-label" htmlFor="company">Empresa</label><input className="info-value" id="company" defaultValue="Tech Solutions Inc." /></div>
              <div className="info-item"><label className="info-label" htmlFor="country">País</label><input className="info-value" id="country" defaultValue="México" /></div>
              <div className="info-item"><label className="info-label" htmlFor="timezone">Zona Horaria</label><input className="info-value" id="timezone" defaultValue="GMT-6 (Ciudad de México)" /></div>
            </div>
            <button type="submit" className="save-btn">💾 Guardar Cambios</button>
          </form>
        </div>

        <div className="profile-section" id="active-plan-section">
          <div className="section-header"><h3 className="section-title"><span className="section-icon">💎</span> Plan Activo</h3></div>
          <div className="current-plan">
            <div className="plan-header">
              <div>
                <div className="plan-name" id="basic-plan-name">Plan Básico</div>
                <div style={{color:'#166534', fontSize:'0.9rem', marginTop:'0.5rem'}}>Plan actual activo</div>
              </div>
              <div className="plan-price">$49<span>/mes</span></div>
            </div>
            <div className="plan-info">
              <div className="plan-info-item"><span className="plan-info-label">Fecha de Inicio</span><span className="plan-info-value">15 Dic 2024</span></div>
              <div className="plan-info-item"><span className="plan-info-label">Próxima Renovación</span><span className="plan-info-value">15 Ene 2025</span></div>
              <div className="plan-info-item"><span className="plan-info-label">Dispositivos Incluidos</span><span className="plan-info-value">50 dispositivos</span></div>
            </div>
            <div className="renewal-progress"><div className="progress-label"><span>Periodo actual</span><span>18 de 31 días</span></div>
              <div className="progress-bar"><div className="progress-fill" style={{width:'58%'}} /></div>
            </div>
          </div>
        </div>

        <div className="profile-section logout-section" id="logout-section">
          <div className="logout-content">
            <div className="logout-icon">🚪</div>
            <h3 className="section-title" style={{justifyContent:'center', border:'none', marginBottom:'1rem'}}>Cerrar Sesión</h3>
            <p className="logout-text">¿Estás seguro de que quieres cerrar sesión? Perderás el acceso a tu cuenta hasta que vuelvas a iniciar sesión.</p>
            <button className="logout-btn" onClick={() => setLogoutModal(true)}> 🔓 Cerrar Sesión </button>
          </div>
        </div>

        <div className={`modal-overlay ${logoutModal ? 'active' : ''}`} id="logout-modal">
          <div className="modal-content">
            <div className="modal-icon">⚠️</div>
            <h3 className="modal-title">¿Cerrar Sesión?</h3>
            <p className="modal-text">Estás a punto de cerrar sesión. ¿Deseas continuar?</p>
            <div className="modal-actions">
              <button className="modal-btn cancel" onClick={() => setLogoutModal(false)}>Cancelar</button>
              <button className="modal-btn confirm" onClick={handleLogoutConfirm}>Cerrar Sesión</button>
            </div>
          </div>
        </div>

        <div className={`toast ${toast.show ? 'show' : ''}`} id="toast"><span>✓</span><span id="toast-message">{toast.message}</span></div>
      </div>
    </div>
  );
}
